import { render, staticRenderFns } from "./RedCodeForm.vue?vue&type=template&id=610815d6&scoped=true"
import script from "./RedCodeForm.vue?vue&type=script&lang=js"
export * from "./RedCodeForm.vue?vue&type=script&lang=js"
import style0 from "./RedCodeForm.vue?vue&type=style&index=0&id=610815d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "610815d6",
  null
  
)

export default component.exports